import { DealerAddressType } from '../CommonTypes';

import './DealerAddress.scss';
type DealerAddressProps = {
    address: DealerAddressType;
};

const DealerAddress = ({ address }: DealerAddressProps): JSX.Element => {
    const { dealerStreetAddressId, dealerStreetAddress } = address;
    const { city, phone, street, zipOrPostalCode } = dealerStreetAddress;
    return (
        <div className='address--wrapper selectable-div-container'>
            <div id={dealerStreetAddressId} className='p-3'>
                <address>
                    {street}
                    <br />
                    {city}
                    <br />
                    {zipOrPostalCode}
                    <br />
                    {phone}
                </address>
            </div>
        </div>
    );
};

export default DealerAddress;
